// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_2wjoExeWWAivXnJFz9WJKs","code":"_1_QfQ6wAzE9rQraZWqFJz-","number":"_3uw8xYMbZT26DZq4vCUMUx"};